import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=fa52e0f6&scoped=true"
import script from "./exam.vue?vue&type=script&lang=js"
export * from "./exam.vue?vue&type=script&lang=js"
import style0 from "./exam.vue?vue&type=style&index=0&id=fa52e0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa52e0f6",
  null
  
)

export default component.exports